// Sticky Add to Cart Button Custom Script
window.addEventListener("load", function () {
  // Get the vertical scroll position
  var scrollY = window.scrollY || window.pageYOffset;
  const scrollBottom =
    document.documentElement.scrollHeight - window.innerHeight - window.scrollY;

  // Perform some action based on the scroll position
  if (scrollY == 0 || scrollBottom == 0) {
    $("sticky-add-to-cart.productView-stickyCart").css("display", "none");
  }

  $("quantity-input button.quantity__button").click(function () {
    setQuantity($(this));
  });

  $("quantity-input input.quantity__input").keyup(function () {
    setQuantity($(this));
  });

  function setQuantity(the) {
    var quantityInput = the
      .parent("quantity-input")
      .find("input.quantity__input");
    var quantity = quantityInput.val();
    $("quantity-input input.quantity__input").val(quantity);
  }

	// Change product variant image
  const selectedOption = $('#productVariantsSelect select.product-single__variants').find('option:selected');
	const id = $('#productVariantsSelect select.product-single__variants').val();
  resetVariants(id);  // Replace with your actual variant ID
  setStickyVariant(selectedOption);

  $('#productVariantsSelect select.product-single__variants').change(function(e) {
		const selectedOption = $(this).find('option:selected');
		const id = $(this).val();
		resetVariants(id);  // Replace with your actual variant ID

    setStickyVariant(selectedOption);
	});

  function setStickyVariant(selectedOption) {
    const img = selectedOption.attr('data-image');
		const price = selectedOption.attr('data-price');
                // YELLOWWEBMONKEY PATCH
                if (price.indexOf('<span class=money>') !== -1) {
                    var newprice = price.replace('<span class=money>','');
                } else {
                  var newprice = price;
                }
		//Change the image when changin the variant.
		$('#productImage').attr('src', img);
		//$('sticky-add-to-cart.productView-stickyCart .sticky-price span.money').text(price);
        $('sticky-add-to-cart.productView-stickyCart .sticky-price span.money').text(newprice);
  }

	// Function to reset product variants
	function resetVariants(defaultVariantId) {
		var selectedVariant = Array();
		$.each(productVariants, function(index, row) {
			if(row.id == defaultVariantId) {
				$.each(row.options, function(i, val) {
					selectedVariant.push(val);
				});
			}
		});
		
		$.each(selectedVariant, function(index, row) {
			if($('variant-radios fieldset input')) {
				$('variant-radios fieldset input').each(function() {
					var el = $(this);
					if($(this).val() == row) {
						el.click();
					}
				});
			}

			if($('variant-selects select')) {
				$('variant-selects select').each(function(i, e) {
					if(index == i) {
						$(this).prop('value', row);
						$('.product-variant-id').val(defaultVariantId);
								// .val(row)
								// .trigger('change');
					}
				});
			}
		});
	}

	// Example usage: call the function with the desired variant ID
});

$(window).scroll(function () {
  // Code from websensepro.com
  const scrollBottom =
    document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
  const scrollTop = $(window).scrollTop();

  if (scrollTop >= 50 && scrollBottom >= 50) {
    $("sticky-add-to-cart.productView-stickyCart").css("display", "block");
    //Otherwise remove inline styles and thereby revert to original stying
  } else {
    $("sticky-add-to-cart.productView-stickyCart").css("display", "none");
  }
});

// Mobile Sticky add to cart.

// Quantity selector